import React, { Component } from 'react'
import { Router, Route, Switch } from 'react-router-dom';

import { history } from '../helpers/history';
import { PrivateRoute} from '../components/PrivateRoute';
import Login from './Login'
import LoginCallback from './LoginCallback'
import Frame from "./Frame";

import '../stylesheets/main.scss'

export default class Root extends Component {
    render() {
        return (
            <div>
                <Router history={history}>
                    <div>
                        <Switch>
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/login/callback" component={LoginCallback} />
                            <PrivateRoute path="/" component={Frame} />
                        </Switch>
                    </div>
                </Router>
            </div>
        )
    }
}
